(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/components/overview/overview-row.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/components/overview/overview-row.js');
"use strict";


class OverviewRow extends React.Component {
  render() {
    const {
      event,
      couponEvent
    } = this.props;
    let classes = 'panel panel-default overview-list-container';
    if (event.eventNumber % 2 === 0) {
      classes += ' row-grey-bg';
    }
    const markings = event.outcomes.map(outcome => {
      let classes = 'mark-part';
      if (couponEvent && couponEvent[outcome.outcomeNumber]) {
        classes += ' bold';
      } else {
        classes += ' weak-font';
      }
      const tag = React.createElement("div", {
        className: classes,
        key: outcome.description
      }, outcome.description);
      return tag;
    });
    return React.createElement("div", {
      className: classes
    }, React.createElement("div", {
      className: "bet-slip-row-left"
    }, event.eventNumber), React.createElement("div", {
      className: "bet-slip-row-middle"
    }, event.eventDescription, React.createElement("br", null), React.createElement("b", null, event.eventComment)), React.createElement("div", {
      className: "bet-slip-row-right"
    }, markings));
  }
}
svs.challenge.OverviewRow = OverviewRow;

 })(window);